import React, { Fragment, useState, useEffect } from 'react'
import axios from 'axios'

import { Modal, ModalHeader, ModalBody, Button, Alert } from 'reactstrap'

import QrReader from "react-qr-reader";
import { tokenConfig } from '../../utils/apiConfig';

const QrScanner = props => {
    const [scannedData, setScannedData] = useState('')
    const [modal, setModal] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [counter, setCounter] = useState(0)

    useEffect(() => {
        if (scannedData) {
            setErrorMessage("")
            setSuccessMessage("")
            setCounter(counter + 1)
            axios.patch('/api/registrations/qrscan', { _id: scannedData }, tokenConfig())
                .then(res => {
                    props.updateStatus(scannedData)
                    setSuccessMessage(`${res.data?.registration?.guests ? res.data?.registration?.guests.length + 1 : '1'} attendees ${res.data.message}`)
                })
                .catch(err => {
                    setErrorMessage(err.response.data)
                })
        }

    }, [scannedData])

    const toggle = () => {
        setModal(!modal)
    }
    return (
        <Fragment>
            <Button color='primary' onClick={toggle}>Scan Qr</Button>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Qr Scanner</ModalHeader>
                <ModalBody>
                    {errorMessage && <Alert color='danger'>{errorMessage}</Alert>}
                    {successMessage && <Alert color='success'>{successMessage}</Alert>}
                    <QrReader
                        onError={err => console.log(err)}
                        onScan={data => setScannedData(data)}
                        style={{ width: "100%" }}
                    />
                </ModalBody>
                <p>{counter}</p>
            </Modal>

        </Fragment>
    )
}

export default QrScanner